import { isEmpty } from 'shared/utils/objectUtils'

export const isRedPointsActive = (
  toggles: Record<string, string | number | boolean> = {}
): boolean => {
  if (
    isEmpty(toggles) ||
    !Object.prototype.hasOwnProperty.call(toggles, 'redpoints.active')
  ) {
    return true
  }

  return Boolean(toggles['redpoints.active'])
}
